import { PlusCircle } from "react-feather";
import { Card, CardBody, Col, Nav, NavItem } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Href, TaskFilter } from "../../Constant";
import { useAppDispatch, useAppSelector } from "../../Redux-Toolkit/Hooks";
import { setTaskFilter } from "../../Redux-Toolkit/Reducers/TaskSlice";
import { NavClassType } from "../../Type/TaskType";
import CreateTag from "./CreateTag";
import HeaderProfile from "./HeaderProfile";
import NewTaskClass from "./NewTask";
import { TaskViewData } from "./TaskViewData";
import { TaskTagData } from "./TaskTagData";
import { useCallback, useState } from "react";

const NavClass = ({ activeToggle }: NavClassType) => {
  const { taskFilter} = useAppSelector((state) => state.task);
  const [tagModal, setTagModal] = useState(false);
  const dispatch = useAppDispatch();
  const tagCallback = useCallback((modal:boolean) => {setTagModal(modal)}, []);

  return (
    <Col xl="3" className="box-col-4e">
      <div className="md-sidebar">
        <Btn tag="a" color="primary" className="md-sidebar-toggle" href={Href} onClick={() => dispatch(setTaskFilter())}>{TaskFilter}</Btn>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${taskFilter ? "open" : ""}`}>
          <div className="email-left-aside">
            <Card>
              <CardBody>
                <div className="email-app-sidebar left-bookmark task-sidebar">
                  <HeaderProfile />
                  <Nav className="main-menu">
                    <NavItem><NewTaskClass /></NavItem>
                    <NavItem><span className="main-title">Views</span></NavItem>
                    <TaskViewData activeToggle={activeToggle} />
                    <NavItem><hr /></NavItem>
                    <NavItem>
                      <span className="f-w-700 main-title">Tags
                        <span className="pull-right" onClick={() => {setTagModal(true)}}><PlusCircle /></span>
                      </span>
                    </NavItem>
                    <CreateTag tagCallback={tagCallback} tagModal={tagModal} setTagModal={setTagModal}/>
                    <TaskTagData activeToggle={activeToggle} />
                  </Nav>
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default NavClass;
